import type { RootState } from 'core/store';
import { select } from 'core/middlewares/utilities';
import { Cookies, getLocationPathname } from 'core/utilities';
import { getAccessToken } from 'core/services/auth';

import { getLocationParams } from 'core/middlewares/effects/orchestrator/workflows/get-location-params';

function* isPageConfirmation() {
  const routes: RootState['settings']['data']['routes'] = yield select(
    ({ settings }: RootState) => settings.data.routes,
  );

  const { path = '' } =
    routes.find(({ path: pathname }) => pathname.includes('/confirmation')) || {};

  const { isExact, params, query } = getLocationParams(getLocationPathname(), path);

  return {
    isExact,
    orderCode: params?.orderCode || '',
    query: query?.get('q') || '',
  };
}

/**
 * Get Bff request options from state
 *
 */
export function* getRequestOptions() {
  const {
    cart: { current, couponUpdate },
    user: {
      data: { cycle: currentCycle, shippingModel, isExtendedCapitation, resellerId },
    },
  }: RootState = yield select((state: RootState) => state);

  const { isExact, orderCode = '', query: queryParam } = yield isPageConfirmation();
  const order = isExact ? orderCode : current.code;

  if (localStorage.getItem(`choose-new-cycle-${resellerId}`)) {
    Cookies.set('currentCycle', `${currentCycle.nextCycle}`, { domain: '.boticario.com.br' });
  } else {
    Cookies.set('currentCycle', `${currentCycle.currentCycle}`, { domain: '.boticario.com.br' });
  }

  const cycle = Cookies.get('currentCycle');

  return {
    accessToken: getAccessToken(),
    orderCode: order,
    couponNumber: couponUpdate.meta.couponNumber,
    cycle,
    code:
      current.shippingModel.distributionCenterCode ||
      shippingModel?.default?.delivery?.distributionCenterCode,
    comboCode: queryParam,
    isExtendedCapitation: isExtendedCapitation && !!Cookies.get('currentCycle'),
    resellerId,
  };
}
